module.exports = __webpack_public_path__ + "img/bl.b0e28335.png";